import { MedicalField } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { FieldControllerProps } from '@dreryk/react-common';
import { Autosuggest, ClassNameProp } from '@dreryk/react-components';

import { serviceProvidingLocationTranslationKeys } from '../../../../../translations';

import {
   medicalFieldItemRenderer,
   medicalFieldLabelExtractor,
   medicalFieldSearchCreator,
} from './MedicalFieldAutosuggest.utils';

type MedicalFieldAutosuggestProps = FieldControllerProps<'medicalField', MedicalField | null> & ClassNameProp;

export const MedicalFieldAutosuggest = (props: MedicalFieldAutosuggestProps): JSX.Element => {
   const controller = props.register(props.name);

   return (
      <Autosuggest<MedicalField>
         label={serviceProvidingLocationTranslationKeys.medicalField}
         placeholder={serviceProvidingLocationTranslationKeys.chooseOrSearchByCodeOrName}
         minChars={0}
         labelExtractor={medicalFieldLabelExtractor}
         itemRenderer={medicalFieldItemRenderer}
         searchCreator={medicalFieldSearchCreator}
         keyProperty={'id'}
         controller={controller}
         testId={props.name}
         className={props.className}
      />
   );
};
